import { forwardRef } from "react";
import "./index.css";

export const Input = forwardRef((props, ref) => {
  const hasPrependIcon = !!props.prependIcon;

  const style = {
    ...props.style,
    paddingLeft: hasPrependIcon ? "40px" : "10px", // more space if icon present
    background: "#fff",
    border: "1.5px solid #64748B",
    fontWeight: "400",
    fontSize: "16px",
    outline: "none",
    color: "#676767",
  };

  return (
    <div className="">
      {props.label && (
        <label className="d-block label-name" htmlFor={props.name}>
          {props.label}
        </label>
      )}
      <div className="input-wrapper" style={{ position: "relative" }}>
        {hasPrependIcon && (
          <span className="prependIcon">{props.prependIcon}</span>
        )}
        <input
          {...props}
          ref={ref}
          disabled={props.isDisabled}
          placeholder={props.placeholder}
          value={props.value}
          style={
            props.error
              ? {
                  ...style,
                  border: "1px solid #ff5b5b",
                  boxShadow: "none",
                  background: "#F7F9FC",
                }
              : style
          }
        />
      </div>
      {props.error && <p className="validate-error">{props.error}</p>}
    </div>
  );
});
